import { Component } from '@angular/core';

@Component({
    selector: 'app-tds',
    templateUrl: './tds.component.html',
    styleUrls: ['./tds.component.less'],
    standalone: false
})
export class TDSComponent {

}








